

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/privacy/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.e36a0435.js","_app/immutable/chunks/scheduler.349e619f.js","_app/immutable/chunks/index.b97ce8f1.js","_app/immutable/chunks/Loading.a5966771.js","_app/immutable/chunks/index.e9bbedad.js"];
export const stylesheets = ["_app/immutable/assets/Loading.218e0f39.css"];
export const fonts = [];
